import { useEffect, useState } from 'react'
import { MIN_SEARCH_LENGTH } from '@/common/const/minSearchLength.const'
import { apiService } from '@/common/services/api.service'

export const useSiteSearchResults = (searchTerm: string = '') => {
    const [searchResults, setSearchResults] = useState<GroupedResult>([])
    const [loading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        void (async () => {
            setSearchResults([])
            setIsLoading(true)
            if (searchTerm.trim().length < MIN_SEARCH_LENGTH) return

            const apiResult = await apiService.getSearchResults(searchTerm)
            const searchResult = apiResult.filter(s => !!s.title)
            const groupedResults = searchResult.reduce((acc: Record<string, SearchResult[]>, current) => {
                acc[current.category] = acc[current.category] || []
                acc[current.category].push(current)
                return acc
            }, {})

            const results = Object.entries(groupedResults)
            setSearchResults(results)
            setIsLoading(false)
        })()
    }, [searchTerm])
    return [searchResults, searchResults.length > 0, loading] as const
}

type GroupedResult = Array<[string, SearchResult[]]>

export interface SearchResult {
    category: string
    pageAlias: string
    title: string
    url: string
}
